import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { map } from 'rxjs/operators';
import { LoginService } from '../../../../login/login.service';
import { LOADING_STATE } from '../../../enums/loadingState.enum';
import { CustomerStoreService } from '../../../services/customer-store.service';
import { PollService } from '../../../services/poll.service';
import { TrackingService } from '../../../services/tracking.service';
import { TRACKING } from '../../../enums/trackingParts.enum';

@Component({
    selector: 'bdo-personal-data-password',
    templateUrl: './personal-data-password.component.html',
    styleUrls: ['./personal-data-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PersonalDataPasswordComponent implements OnInit {
  @Input() disabled: boolean = false;
  @Output() edit: EventEmitter<boolean> = new EventEmitter();
  public LoadingState = LOADING_STATE;
  public state = LOADING_STATE.IDLE;
  public isInEditMode = false;
  public username: string;

  constructor(
    public customerStore: CustomerStoreService,
    private loginService: LoginService,
    private trackingService: TrackingService,
    private pollService: PollService
  ) { }

  ngOnInit(): void {
    this.state = LOADING_STATE.LOADING;

    // Get Username
    this.loginService.getUsername().pipe(
      map(username => this.username = username)
    ).subscribe({
        next: () => {
          this.state = LOADING_STATE.IDLE;
        },
        error: () => {
          this.state = LOADING_STATE.ERROR;
        }
    });
  }

  onEditDone(result: 'success' | 'cancel') {
    this.isInEditMode = !this.isInEditMode;
    this.pollService.activatePoll({ pollId: 4, triggerPoint: 'PersoenlicheDaten', extraContext: 'password', delay: 6500 });
    this.trackingService.postSimpleTracking('Persönliche Daten Password', result === 'success' ? TRACKING.ACTION.SUCCESS : TRACKING.ACTION.CANCEL);
    this.edit.emit(false);
  }
}
